"use client";

import { Suspense, useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

const isMetaPixelEnabled = () => {
  return window.__instantTranscriberMarketingConsent !== false;
};

const getCurrentPath = (pathname, searchParams) => {
  const query = searchParams?.toString();
  return query ? `${pathname}?${query}` : pathname;
};

function MetaPixelPageViewTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!pathname || !isMetaPixelEnabled() || typeof window.fbq !== "function") return;

    const path = getCurrentPath(pathname, searchParams);
    if (window.__instantTranscriberMetaPixelLastPageViewPath === path) return;

    window.__instantTranscriberMetaPixelLastPageViewPath = path;
    window.fbq("track", "PageView");
  }, [pathname, searchParams]);

  return null;
}

export default function MetaPixelEvents() {
  return (
    <Suspense fallback={null}>
      <MetaPixelPageViewTracker />
    </Suspense>
  );
}
